





















import { Component, Prop, Vue } from "vue-property-decorator";
import LeftSideGosSign from "./LeftSide/LeftSideGosSign.vue";
import LeftSideCar from "./LeftSide/LeftSideCar.vue";
import PrecheckDate from "_C/main/Precheck/PrecheckDate.vue";
import { Widget } from "@/services/index.defs";
import App from "@/App.vue";
@Component({ components: { LeftSideCar, PrecheckDate, LeftSideGosSign } })
export default class LeftSide extends Vue {
    ratelimit = false;
    get showRatelimit() {
        // 🤡♿🦽👨‍🦽 костыль, но по правильному переделывать сильно долго
        return this.ratelimit && this.$store.direct.state.ratelimitVisible;
    }

    get widget(): Widget {
        return this.$store.direct.state.widget;
    }
    get leftSideClass() {
        const isGos = this.widget.gosSignOn;
        const isMd = (this.$root as App).br.mdOnly;
        const isXs = (this.$root as App).br.xsOnly;
        if ((!isGos && !isMd) || isXs) return "w-100";
        else return "";
    }
}
